<template>
  <div id="app">
    <Filters @change="applyFilters" @toggle="toggleFilters" :visible="filtersVisible"></Filters>
    <Results @toggle="toggleFilters" :visible="!filtersVisible" :loading="!dataReady"></Results>
  </div>
</template>

<script>
import Filters from './components/Filters.vue';
import Results from './components/Results.vue';
import State from "./services/state.js";
import DataLayer from "./services/datalayer.js";
import Config from './services/config';
import Utils from './services/utils';
import Labels from './services/labels';

export default {
  name: 'app',
  components: {
    Filters, Results
  },
  data () {
    return {
      filterValues: State.filterValues,
      dataReady: false,
      filterTimer: null,
      filtersVisible: true,
    }
  },
  mounted() {
    Config.init();
    Labels.init();
    DataLayer.getProducts().then(res => {
      console.log("Product data received");
      Utils.initArray(State.products, res.data);
      Utils.initFilters(State.filters, State.products);
      State.trigger("filters-updated", State.filters);
      setTimeout(() => {
        this.dataReady = true;
      })
    });
    DataLayer.getEcolabelInfo().then (res => {
      if (res.data && res.data.length > 0) {
        console.log("Ecolabel data received.");
        State.trigger("labels-updated", res.data);
      }
    }).catch(err => console.error(err));
  },
  methods: {
    applyFilters(filters) {
      if (this.filterTimer) clearTimeout(this.filterTimer);
      if (this.dataReady) this.filterTimer = setTimeout(() => {
        State.trigger("filters-changed", filters);
        this.filterValues = filters;
        DataLayer.recordFilters(this.filterValues);
        this.filterTimer = null;
      }, 300);
    },
    toggleFilters () {
      this.filtersVisible = !this.filtersVisible;
    }
  }
}
</script>

<style>
#app {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: row;
}

@media all and (max-width:800px) {
  #app {
    box-sizing: border-box;
  }
}
</style>
